import { axiosObject } from '../setup';

function addHistoricalRatesToProduction(payload) {
  return new Promise((resolve, reject) => {
    let uri = `${process.env.NX_PUBLIC_RATES_API_URL}/add-historical-rates`;
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function addHistoricalRatesToStaging(payload) {
  return new Promise((resolve, reject) => {
    let uri = `${process.env.NX_PUBLIC_RATES_STAGING_API_URL}/add-historical-rates`;
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export { addHistoricalRatesToProduction, addHistoricalRatesToStaging };
